<template>
  <div id="app">
    <HomeHeader />
    <router-view />
  </div>
</template>

<script>
import "./assets/css/main.css";
import HomeHeader from "@/components/HomeHeader.vue";

export default {
  name: "App",
  components: {
    HomeHeader,
  },
};
</script>

<!-- IMPORTANT: do NOT use "scoped" here -->
<style>
html,
body {
  margin: 0;
  height: 100%;
  background-color: var(--backgroundColor);
}

#app {
  display: flex;
  flex-direction: column;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
}
</style>
